import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdatestoreMainFieldsData,
	billerDetailsTableColumns,
	electricityHvacDetails,
	electricityHvacDetailsFields,
	getColDefaultValue,
	leaseDetails,
	storeBasicDetailsFields,
	storeCamTableColumns,
	storeDepositTableColumns,
	storeMainFields,
	storeRentTableColumns,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { constraintsOptions } from "data/globalData";
import { inputTypes, statusOptions } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useState } from "react";

const AddOrEditModal = ({
	modal,
	setModal,
	type,
	selectedObj,
	createDetailsApi,
	selectedStore,
	setSelectedStore,
	handleUpdateDetails,
}) => {
	const defFields = (() => {
		let obj = {};
		electricityHvacDetailsFields?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [electricityHvacDetails, setelectricityHvacDetails] = useState(
		type === addOrEditModelAction.UPDATE ? selectedObj : defFields
	);

	const handleModalclose = () => {
		setModal(false);
	};
	const handleElectricityHvacCallbackFun = (data) => {
		console.log("handleElectricityHvacCallbackFun", data);
		if (type === addOrEditModelAction.UPDATE) {
			let filtredData = selectedStore?.electricityHvacDetails.filter((data) => data.id !== electricityHvacDetails.id);
			let eleHvacDetails = [...filtredData, electricityHvacDetails];
			setSelectedStore({ ...selectedStore, electricityHvacDetails: eleHvacDetails });
		} else {
			let eleHvacDetails = [...selectedStore?.electricityHvacDetails, data];
			setSelectedStore({ ...selectedStore, electricityHvacDetails: eleHvacDetails });
		}
		setelectricityHvacDetails(defFields);
		setModal(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		let updatedDeposit = { ...electricityHvacDetails, ebo_store_v4_id: selectedStore.store_code };
		if (type === addOrEditModelAction.UPDATE) {
			handleUpdateDetails(
				storesLinkedTables.store_electricity_hvac_details.seqMethod,
				updatedDeposit,
				handleElectricityHvacCallbackFun
			);
		} else {
			createDetailsApi(
				storesLinkedTables.store_electricity_hvac_details.seqMethod,
				updatedDeposit,
				handleElectricityHvacCallbackFun
			);
		}
	};

	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Deposit </Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{electricityHvacDetailsFields?.map((row) => {
							return (
								<RenderInputField
									column={row}
									data={electricityHvacDetails}
									setData={setelectricityHvacDetails}
									width="24%"
									selectOptObjName={"option_data"}
								/>
							);
						})}
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button
						variant="contained"
						sx={{ justifySelf: "center" }}
						disabled={selectedStore.status === statusOptions.PUBLISHED.key}
						type="submit">
						{type === addOrEditModelAction.UPDATE ? "UPDATE" : "CREATE"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
